import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import ItemDelete from '../../components/Delete'

const IncidentCategoryDelete = () => (
  <ItemDelete
    routeName={ROUTE_NAME}
    apiUrl={API_URL}
    label={(item) => `Incident Category (#${item.id}): ${item.name}`}
  />
)

export default IncidentCategoryDelete
